<template>
  <div>
    <!-- Personal Information start -->
    <v-card class="r_tabsform_card mb-5">
      <v-card-title class="r_form_card_title ext_pdg_to_lvl">
        Personal Information
        <!-- <v-spacer></v-spacer>
        <v-spacer></v-spacer>
        <v-spacer></v-spacer>
        <v-spacer></v-spacer>
        <v-spacer></v-spacer>      
        
        <router-link
            :to="{ name: 'student-be-mentor-form' }"
            v-slot="{ href, navigate }"
        >
            <a :href="href" @click="navigate">
                <span class="menu-text r_form_top_search"><i class="fa fa-edit"></i></span>
            </a>
        </router-link> -->
      </v-card-title>
      <hr class="r_form_card_top_hr" />
      <div class="col-md-12 p-5">
        <div class="col-md-12 row p-0 m-0">
          <div class="col-md-12 row m-0 bg-light">
            <div class="col-md-6 p-0">
              <umer>Name</umer>
            </div>
            <div class="col-md-6 p-0">
              <span>{{ name }}</span>
            </div>
          </div>
          <div class="col-md-12 row m-0">
            <div class="col-md-6 p-0">
              <umer>Email</umer>
            </div>
            <div class="col-md-6 p-0">
              <span>{{ email }}</span>
            </div>
          </div>
          <div class="col-md-12 row m-0 bg-light">
            <div class="col-md-6 p-0">
              <umer>CNIC</umer>
            </div>
            <div class="col-md-6 p-0">
              <span>{{ cnic }}</span>
            </div>
          </div>
          <div class="col-md-12 row m-0">
            <div class="col-md-6 p-0">
              <umer>Born on</umer>
            </div>
            <div class="col-md-6 p-0">
              <span>{{ dob }}</span>
            </div>
          </div>
          <div class="col-md-12 row m-0 bg-light">
            <div class="col-md-6 p-0">
              <umer>Living in</umer>
            </div>
            <div class="col-md-6 p-0">
              <span>{{ city }}, {{ country }}</span>
            </div>
          </div>
        </div>
        <div class="p-5 mt-5">
          <router-link
            :to="{ name: 'student-be-mentor-form' }"
            v-slot="{ href, navigate }"
            class="r_form_add_more_btnnn"
          >
            <a :href="href" @click="navigate">
              Edit
            </a>
          </router-link>
        </div>
      </div>
    </v-card>
    <!-- Personal Information end -->
    <!-- Summary Information start -->
    <v-card class="r_tabsform_card mb-5 mt-8">
      <v-card-title class="r_form_card_title ext_pdg_to_lvl"
        >Education</v-card-title
      >
      <hr class="r_form_card_top_hr" />
      <div class="col-md-12 p-5">
        <div class="col-md-12 row p-0 m-0">
          <div class="col-12 row m-0 p-0">
            <div class="col-2 mb-4 p-0">
              <h6 class="m-0 pt-2 pl-4 color-uni-blue">Program</h6>
            </div>
            <div class="col-2 mb-4 mt-2 p-0">
              <h6 class="m-0 color-uni-blue">Level</h6>
            </div>
            <div class="col-2 mb-4 p-0 pt-2">
              <h6 class="m-0 color-uni-blue">Status</h6>
            </div>
            <div class="col-2 mb-4 p-0 pt-2">
              <h6 class="m-0 color-uni-blue">Institute</h6>
            </div>
            <div class="col-2 mb-4 p-0 pt-2">
              <h6 class="m-0 color-uni-blue">Obtained Marks</h6>
            </div>
            <div class="col-2 mb-4 p-0 pt-2">
              <h6 class="m-0 color-uni-blue">CGPA/Grades</h6>
            </div>
            <div
              class="row m-0 col-12 p-0"
              v-for="(item, index) in educations"
              :key="index"
              :class="index % 2 == 0 ? 'bg-light' : ''"
            >
              <div class="col-2 pl-4">
                <umer class="">{{ item.program }}</umer>
              </div>
              <div class="col-2 d-block mt-3 p-0">
                <p>{{ item.level }}</p>
              </div>
              <div class="col-2 p-0">
                <p>
                  {{
                    item.inProgress == 1 || item.inProgress == true
                      ? "In progress"
                      : "Completed"
                  }}
                </p>
              </div>
              <div class="col-2 p-0">
                <p>{{ item.institute }}</p>
              </div>
              <div class="col-2 p-0">
                <p>{{ item.obtainedMarks }}</p>
              </div>
              <div class="col-2 p-0">
                <p>{{ item.grades }}</p>
              </div>
            </div>
          </div>
        </div>
        <div class="p-5 mt-5">
          <router-link
            :to="{ name: 'student-be-mentor-form' }"
            v-slot="{ href, navigate }"
            class="r_form_add_more_btnnn"
          >
            <a :href="href" @click="navigate">
              Edit
            </a>
          </router-link>
        </div>
      </div>
    </v-card>
    <!-- Summary Information end -->
    <!-- Skills start -->
    <v-card class="r_tabsform_card mb-5 mt-8">
      <v-card-title class="r_form_card_title ext_pdg_to_lvl"
        >Skills</v-card-title
      >
      <hr class="r_form_card_top_hr" />
      <div class="col-md-12 p-5">
        <div class="col-md-12 row p-0 m-0">
          <div class="col-md-12 row p-0 m-0">
            <div class="col-md-4 mb-4 p-0">
              <h6 class="m-0 pt-2 pl-4 color-uni-blue">Field</h6>
            </div>
            <div class="col-md-4 mb-4 p-0">
              <h6 class="m-0 pt-2 pl-4 color-uni-blue">Skills</h6>
            </div>
            <div class="col-md-4 mb-4 p-0">
              <h6 class="m-0 pt-2 pl-4 color-uni-blue">Experience</h6>
            </div>
            <div
              class="col-md-12 row m-0"
              v-for="(item, index) in skills"
              :key="index"
              :class="index % 2 == 0 ? 'bg-light' : ''"
            >
              <div class="col-md-4 p-0">
                <umer>{{ item.field.value }}</umer
                ><br />
              </div>
              <div class="col-md-4 p-0">
                <span>{{ item.skill_name.value }}</span>
              </div>
              <div class="col-md-4 p-0">
                <!-- <span
                  class="progress-bar progress-bar bg-uni-green"
                  role="progressbar"
                  aria-valuenow="100"
                  aria-valuemin="0"
                  aria-valuemax="100"
                  style="width: 100%"
                > -->
                {{ item.experience }} years experience
                <!-- </span> -->
                <!-- <span
                  class="progress-bar progress-bar bg-danger"
                  role="progressbar"
                  aria-valuenow="20"
                  aria-valuemin="0"
                  aria-valuemax="100"
                  style="width: 20%"
                > -->

                <!-- </span> -->
                <!-- <span
                  class="progress-bar progress-bar bg-warning"
                  role="progressbar"
                  aria-valuenow="50"
                  aria-valuemin="0"
                  aria-valuemax="100"
                  style="width: 50%"
                >
                  Entry Level
                </span> -->
              </div>
            </div>
          </div>
        </div>
        <div class="p-5 mt-5">
          <router-link
            :to="{ name: 'student-be-mentor-form' }"
            v-slot="{ href, navigate }"
            class="r_form_add_more_btnnn"
          >
            <a :href="href" @click="navigate">
              Edit
            </a>
          </router-link>
        </div>
      </div>
    </v-card>
    <!-- Skills end -->
    <!-- Work Experience Information start -->
    <v-card class="r_tabsform_card mb-5 mt-8">
      <v-card-title class="r_form_card_title ext_pdg_to_lvl"
        >Work Experience
      </v-card-title>
      <hr class="r_form_card_top_hr" />
      <div class="col-md-12 p-5">
        <div class="col-md-12 row p-0 m-0">
          <div
            class="col-md-12 row m-0"
            v-for="(item, index) in work_experience"
            :key="index"
            :class="index % 2 == 0 ? 'bg-light' : ''"
          >
            <div class="col-md-6 p-0">
              <umer>{{ item.companyName }}</umer
              ><br />
              <span class="font-weight-bold" style="color: #2eca8b">{{
                item.designation
              }}</span
              ><br />
              <span>{{ item.startingDate }} - {{ item.endDate }}</span>
            </div>
            <div class="col-md-12 p-0">
              <span v-html="item.description"></span>
            </div>
          </div>
        </div>
        <div class="p-5 mt-5">
          <router-link
            :to="{ name: 'student-be-mentor-form' }"
            v-slot="{ href, navigate }"
            class="r_form_add_more_btnnn"
          >
            <a :href="href" @click="navigate">
              Edit
            </a>
          </router-link>
        </div>
      </div>
    </v-card>
    <!-- Work Experience Information end -->

    <!-- Certificates start -->
    <v-card class="r_tabsform_card mb-5 mt-8">
      <v-card-title class="r_form_card_title ext_pdg_to_lvl"
        >Certificates</v-card-title
      >
      <hr class="r_form_card_top_hr" />
      <div class="col-md-12 p-5">
        <div class="col-md-12 row p-0 m-0">
          <div class="col-12 row m-0 p-0">
            <div class="col-3 mb-4 p-0">
              <h6 class="m-0 pt-2 pl-4 color-uni-blue">Certificate Name</h6>
            </div>
            <div class="col-3 mb-4 mt-2 p-0">
              <h6 class="m-0 color-uni-blue">Awarded By</h6>
            </div>
            <div class="col-3 mb-4 p-0 pt-2">
              <h6 class="m-0 color-uni-blue">Starting Date</h6>
            </div>
            <div class="col-3 mb-4 p-0 pt-2">
              <h6 class="m-0 color-uni-blue">End Date</h6>
            </div>
            <div
              class="row m-0 col-12 p-0"
              v-for="(item, index) in certificates"
              :key="index"
              :class="index % 2 == 0 ? 'bg-light' : ''"
            >
              <div class="col-3">
                <umer class="">{{ item.certificateName }}</umer>
              </div>
              <div class="col-3 d-block mt-3 p-0">
                <p>{{ item.awardedBy }}</p>
              </div>
              <div class="col-3">
                <p>{{ item.startingDate }}</p>
              </div>
              <div class="col-3">
                <p>{{ item.endDate }}</p>
              </div>
            </div>
          </div>
        </div>
        <div class="p-5 mt-5">
          <router-link
            :to="{ name: 'student-be-mentor-form' }"
            v-slot="{ href, navigate }"
            class="r_form_add_more_btnnn"
          >
            <a :href="href" @click="navigate">
              Edit
            </a>
          </router-link>
        </div>
      </div>
    </v-card>
    <!-- Certificates end -->
  </div>
</template>

<script>
import GeneralService from "@/MainServices/GeneralService.js";
import IndexService from "@/MainServices/IndexService.js";
import axios from "axios";
import API from "@/core/api";

export default {
  data() {
    return {
      name: "",
      dob: "",
      email: "",
      cnic: "",
      phone: "",
      country_id: "",
      country: "",
      city_id: "",
      city: "",
      area_of_expertise: "",
      interested_in: "",
      industry: "",
      user_id: 0,
      countries: [],
      allCities: [],
      cities: [],
      selected_cities: "",
      skills: [],
      work_experience: [],
      certificates: [],
      saved_cnic: "",
      educations: [],
      allSkills: [],
      tokens: [
        "HtDFLJIJNa4mwOEHAw45TLtgLy3Zzi3k85kKZV6p",
        "HtDFLJI54236wOEHAw4grop1Ly3Zzi3k85kKZV6p",
        "HtDF7ybds236wOEHAw4grop1Ly3Zzi3mnbvcZV6p",
        "HtDFpoi8u236wOEHAw4grop1Ly3ZqwertbvcZV6p",
        "HtDFpoi8u236wOE45698rop1Ly3Zqwe52031ZV6p",
        "HtDFpoi8u236wOE45698ropoijhbvcxz2031ZV6p",
        "HtDFpoi8u236wOE45698rop123poi456t031ZV6p",
        "HtDFpoi8u236wOE456qwedsa3456bf8sj031ZV6p",
        "HtDFpoi8u236wOE45698rop12742651erts1ZV6p",
        "HtDFpoi8u236wOE456qwed745632ertuj031ZV6p",
      ],
      token: `Bearer ${localStorage.getItem("token")}`,
    };
  },
  methods: {
    fetchDataFromJob4u(e, c) {
      IndexService.getCountries().then((res) => {
        this.countries = [];
        res.data.map((el) => {
          if (el.id == this.country_id) {
            this.country = el.country;
          }
        });
      });

      IndexService.getCities().then((res) => {
        this.cities = [];
        this.cities = res.data;
        res.data.map((el) => {
          // this.cities.push({ id: el.id, value: el.city });
          if (el.id == this.city_id) {
            this.city = el.city;
          }
        });
      });

      axios.defaults.headers.common["Authorization"] = this.token;
      let t = this.tokens[Math.floor(Math.random() * 10)];

      axios
        .post(`${API.API_JOB4U}/std-career-profile`, {
          token: t,
          email: e,
          cnic: c,
        })
        .then((res) => {
          if (res.data) {
            if (res.data.jobFunctions.length > 0) {
              this.jobFunctions = [];
              this.jobFunctionsCh = [];

              var rFirst = 0;

              res.data.jobFunctions.map((el) => {
                this.jobFunctions.push({
                  id: el.id,
                  value: el.job_function_name,
                });
                this.jobFunctionsCh.push({
                  id: el.id,
                  value: el.job_function_name,
                  text: el.job_function_name,
                });
                if (
                  res.data.area_of_expertise.indexOf(el.job_function_name) !==
                  -1
                ) {
                  if (rFirst == 0) {
                    this.area_of_expertise = el.job_function_name;
                  } else {
                    this.area_of_expertise += ", " + el.job_function_name;
                  }
                  rFirst++;
                }
              });
            }

            if (res.data.jobShifts.length > 0) {
              this.jobShifts = [];

              var rFirst = 0;

              res.data.jobShifts.map((el) => {
                this.jobShifts.push({ id: el.id, value: el.job_shift });

                if (res.data.interested_in.indexOf(el.job_shift) !== -1) {
                  if (rFirst == 0) {
                    this.interested_in = el.job_shift;
                  } else {
                    this.interested_in += ", " + el.job_shift;
                  }
                  rFirst++;
                }
              });
            }

            if (res.data.jobIndustries.length > 0) {
              this.jobIndustries = [];
              var rFirst = 0;
              res.data.jobIndustries.map((el) => {
                this.jobIndustries.push({ id: el.id, value: el.industry_name });

                if (res.data.industry.indexOf(el.industry_name) !== -1) {
                  if (rFirst == 0) {
                    this.industry = el.industry_name;
                  } else {
                    this.industry += ", " + el.industry_name;
                  }
                  rFirst++;
                }
              });
            }

            var rFirst = 0;
            this.cities.map((el) => {
              if (res.data.willing_to_relocate.indexOf(el.city) !== -1) {
                if (rFirst == 0) {
                  this.selected_cities = el.city;
                } else {
                  this.selected_cities += ", " + el.city;
                }
                rFirst++;
              }
            });

            // if(res.data.allSkills.length > 0) {
            //   res.data.allSkills.map((el) => {
            //     this.allSkills.push({ id: el.id, value: el.skill_name, text: el.skill_name})
            //   });
            // }

            if (res.data.skills.length > 0) {
              this.skills = [];

              for (let i = 0; i < res.data.skills.length; i++) {
                this.skills.push({
                  field: res.data.skills[i].job_funcation_ch,
                  skill_name: res.data.skills[i].skill,
                  experience: res.data.skills[i].experience,
                });
              }
            }

            if (res.data.work_experience.length > 0) {
              this.work_experience = [];
              for (let i = 0; i < res.data.work_experience.length; i++) {
                this.work_experience.push({
                  companyName: res.data.work_experience[i].companyName,
                  designation: res.data.work_experience[i].designation,
                  startingDate: res.data.work_experience[i].startingDate,
                  endDate: res.data.work_experience[i].endDate,
                  description: res.data.work_experience[i].description,
                });
              }
            }

            if (res.data.certificate.length > 0) {
              this.certificates = [];
              for (let i = 0; i < res.data.certificate.length; i++) {
                this.certificates.push({
                  certificateName: res.data.certificate[i].certificateName,
                  awardedBy: res.data.certificate[i].awardedBy,
                  startingDate: res.data.certificate[i].startingDate,
                  endDate: res.data.certificate[i].endDate,
                });
              }
            }
          }
        })
        .catch((err) => {
          // console.log('job4u err', err);
        });
    },
  },
  mounted() {
    GeneralService.getStdCareerProfle()
      .then((res) => {
        if (res.data) {
          this.name = res.data.name;
          this.email = res.data.email;
          this.user_id = res.data.id;
          if (res.data.contact != null) {
            this.phone = res.data.contact;
          }
          if (res.data.cnic != null) {
            this.cnic = res.data.cnic;
          }
          if (res.data.cnic != null) {
            this.saved_cnic = res.data.cnic;
          }
          this.fetchDataFromJob4u(res.data.email, res.data.cnic);

          if (res.data.profile != null) {
            if (res.data.profile.dob != null) {
              this.dob = res.data.profile.dob;
            }
            this.country_id = parseInt(res.data.profile.country);
            this.city_id = parseInt(res.data.profile.city);
            this.personal_summary = res.data.profile.personal_summary;
          }

          if (res.data.educations.length > 0) {
            this.educations = [];
            for (let i = 0; i < res.data.educations.length; i++) {
              this.educations.push({
                level: res.data.educations[i].level.level,
                program: res.data.educations[i].program.program,
                startDate: res.data.educations[i].start_date,
                endDate: res.data.educations[i].end_date,
                institute: res.data.educations[i].institute.name,
                inProgress: res.data.educations[i].in_progress,
                obtainedMarks: res.data.educations[i].obtained_marks,
                grades: res.data.educations[i].grades,
              });
            }
          }
        }
      })
      .catch((error) => {
        // console.log("error", error);
      });
  },
};
</script>

<style>
.header-fixed.subheader-fixed.subheader-enabled .wrapper {
  padding-top: 89px !important;
}
p,
span {
  font-size: 14px;
}
p,
span {
  margin: 0 !important;
}
</style>
